<template>
    <div class="tag-status">
        <CompassTag :color="information.color" :size="size" :icon="information.icon">
            {{ label }}
        </CompassTag>
    </div>
</template>
<script>
import { allStatus, deliveryStatus, ocrState, promotionStatus } from 'Dictionaries/statusColors';

export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['small', 'medium', 'large'].includes(value),
        },
        type: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'delivery', 'ocr', 'promotion'].includes(value),
        },
    },
    computed: {
        information() {
            const status = this.id.toLowerCase();

            switch (this.type) {
                case 'delivery':
                    return deliveryStatus[status];
                case 'ocr':
                    return ocrState[status];
                case 'promotion':
                    return promotionStatus[status];
                default:
                    return allStatus[status];
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.tag-status {
    align-items: center;
    display: flex;
    height: 100%;
}
</style>
